import { render, staticRenderFns } from "./register-hub.vue?vue&type=template&id=e63ec664&scoped=true&"
import script from "./register-hub.vue?vue&type=script&lang=js&"
export * from "./register-hub.vue?vue&type=script&lang=js&"
import style0 from "./register-hub.vue?vue&type=style&index=0&id=e63ec664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63ec664",
  null
  
)

export default component.exports